import VueAnalytics from 'vue-analytics'
import Vue from 'vue'
import VueCookie from 'vue-cookie'
import { Plugin } from 'vue-fragment'
import App from './App.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faUserSecret,
  faDoorClosed,
  faVolumeUp,
  faVolumeMute,
  faTimesCircle,
  faThumbsUp
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import router from './router'
import store from './store'
import './directives'
import './plugins/artwork-fireworks'
import './plugins/eventbus'

import Footer from '@/components/shared/Footer'
import Button from '@/components/shared/Button'
import LoadingOverlay from '@/components/shared/LoadingOverlay'

// iconfont
library.add(faUserSecret, faDoorClosed, faVolumeMute, faVolumeUp, faTimesCircle, faThumbsUp)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

// analytics
Vue.use(VueAnalytics, {
  id: 'UA-146490865-1',
  router
})

// global component
Vue.component('km-button', Button)
Vue.component('km-loading-overlay', LoadingOverlay)
Vue.component('km-footer', Footer)

Vue.use(Plugin)

Vue.use(VueCookie)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
